// Shared FE auth constants: the portal-identity header sent with sign-in and the
// single failure message every sign-in rejection uses.

/**
 * Header carrying the portal a sign-in request originated from.
 *
 * The API has no other way to know which portal a request came from — portal
 * identity lives only in the frontend bundle — so sign-in states it explicitly
 * and the server rejects a mismatch before a session row is written.
 *
 * TODO: Tenant-level comparison: https://app.asana.com/1/1206214889537900/project/1206881612175705/task/1218418427138239?focus=true
 */
export const PORTAL_TYPE_HEADER = 'x-portal-type';

export const PORTAL_TYPES = ['internal', 'client'] as const;
export type PortalType = (typeof PORTAL_TYPES)[number];

export function isPortalType(value: unknown): value is PortalType {
  return typeof value === 'string' && (PORTAL_TYPES as readonly string[]).includes(value);
}

/**
 * The only message a sign-in failure may produce, on the wire and on screen.
 *
 * The string matches Better Auth's own `INVALID_EMAIL_OR_PASSWORD`, so a 
 * rejection raised by our portal check is identical to one raised by
 * its credential check.
 */
export const INVALID_CREDENTIALS_MESSAGE = 'Invalid email or password';
